import { NgModule } from "@angular/core";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
    declarations: [],
    imports: [MatDatepickerModule,
        MatNativeDateModule,
        MatSnackBarModule,
        MatIconModule],
    exports: [MatDatepickerModule,
        MatNativeDateModule,
        MatSnackBarModule,
        MatIconModule],
    providers: [MatDatepickerModule]
})
export class AngularMaterialModule { }